import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {MatDialogActions, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';

@Component({
    selector: 'app-mod-release-help-dialog',
    templateUrl: './mod-release-help-dialog.component.html',
    styleUrls: ['./mod-release-help-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogActions, MatButton]
})
export class ModReleaseHelpDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<ModReleaseHelpDialogComponent>>(MatDialogRef);


  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }

}
